module.exports = __webpack_public_path__ + "static/media/fit-page.e3c27c8c.svg";